import { render, staticRenderFns } from "./outOrg.vue?vue&type=template&id=bdfb7a8e&scoped=true"
import script from "./outOrg.vue?vue&type=script&lang=js"
export * from "./outOrg.vue?vue&type=script&lang=js"
import style0 from "./outOrg.vue?vue&type=style&index=0&id=bdfb7a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfb7a8e",
  null
  
)

export default component.exports